import { faFolder } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellNameText, FolderIconWrapper } from 'pages/Settings/FileLibrary/styled';
import { tokens } from 'styles/tokens';

import { createFileLibraryDirentNavPath, DirentIdentityInfo } from '../path';
import { FilesLinkCell } from './styled';

export type FolderNameCellProps = Readonly<{
    folderData: { name: string } & DirentIdentityInfo;
    prefetch?: () => void;
}>;

export function FolderNameCell({ folderData, prefetch }: FolderNameCellProps) {
    return (
        <FilesLinkCell
            to={createFileLibraryDirentNavPath(folderData, 'folder')}
            onPointerEnter={prefetch}
            iconColor={tokens.icon.actionActive}
        >
            <FolderIconWrapper>
                <FontAwesomeIcon icon={faFolder} color={tokens.folder.icon} size="3x" />
            </FolderIconWrapper>
            <CellNameText className="ellipsis-1-line" title={folderData.name}>
                {folderData.name}
            </CellNameText>
        </FilesLinkCell>
    );
}
